import React, { FC, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getLangStrings } from '../redux/general';
import { getPages } from '../redux/pages';
import { getGeneralSettings } from '../redux/general';
import HomePage from '../screens/home/home';
import TextPage from '../screens/textpage/textpage';
import RequestPage from '../screens/request/request';
import NoMatchPage from '../screens/404/404';
import AccountPage from '../screens/account/overview';
import ContactPage from '../screens/contact/contact';
import AccountPersonalInfoPage from '../screens/account/subpages/personal_info/personal_info';
import LoginPage from '../screens/login/login';
import FaqPage from '../screens/faq/faq';
import ValidateAccountPage from '../screens/validate-account/validate-account';
import BillingPage from '../screens/account/subpages/billing/billing';
import ForgotPassword from '../screens/forgotPassword/forgotPassword';
import NewPasswordPage from '../screens/newPassword/newPassword';

const Navigation: FC = (props) => {
  const dispatch = useDispatch<any>();

  useEffect(() => {
    dispatch(getLangStrings());
    dispatch(getPages());
    dispatch(getGeneralSettings());
  }, []);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/request' element={<RequestPage />} />
        <Route path='/account' element={<AccountPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/sign-in' element={<LoginPage />} />
        <Route path='/account/personal' element={<AccountPersonalInfoPage />} />
        <Route path='/account/billing/:idForm' element={<BillingPage />} />
        <Route path='/about-us' element={<TextPage />} />
        <Route path='/terms-and-conditions' element={<TextPage />} />
        <Route path='/cookie-policy' element={<TextPage />} />
        <Route path='/copyright-notice' element={<TextPage />} />
        <Route path='/privacy-statement' element={<TextPage />} />
        <Route path='/faq' element={<FaqPage />} />
        <Route path='/validate-account/:salt' element={<ValidateAccountPage />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/new-password/:token' element={<NewPasswordPage />} />
        <Route element={<NoMatchPage />} />
      </Routes>
    </Router>
  );
};

export default Navigation;
